<template lang="pug">
  div
    doc-markdown(source=`
    ## Profiling Input \`profiling-input\`
    Intermediary wrapper between our profiling Sections and the \`sw-input\` generic component. Handles styling & error management.
    `)

    doc-preview(vue=`
    profiling-input.py-2(
      v-model="value"
      :error="error"
      :error-message="errorMessage"
      class='w-1/3'
      data-purpose-prop="example_input"
      description="In which city was founded Seraphin ?"
      placeholder="Cute placeholder"
      @blur="displayError = true"
      @focus="displayError = false"
      @keydown.enter.native="$event.target.blur()"
    )

    <script>
      ...
      data () {
        return {
          value: null,
          displayError: false,
        };
      },
      computed: {
        error () { return this.displayError && this.value?.toLowerCase() !== 'brussels'; },
        errorMessage () { return this.value ? 'Wrong answer !' : 'Type something'; },
      },
      ...
    </script>
    `)
      profiling-input.py-2(
        v-model="value"
        :error="error"
        :error-message="errorMessage"
        class='w-1/3'
        data-purpose-prop="example_input"
        description="In which city was founded Seraphin ?"
        placeholder="Cute placeholder"
        @blur="displayError = true"
        @focus="displayError = false"
        @keydown.enter.native="$event.target.blur()"
      )

    doc-markdown(source=`
    ### Properties
  | Props               | Description                                           | Type           | Default |
  |---------------------|-------------------------------------------------------|----------------|---------|
  | \`value\` (v-model) | Value of the input.                                   | String, Number | -       |
  | \`error\`           | Whether the error message should be displayed or not. | Boolean        | false   |
  | \`error-message\`   | Error message displayed below the input.              | String         | -       |
  | \`description\`     | Label displayed above the input.                      | String         | -       |
  | \`prefix-text\`     | Prefix inside the input (such as '€', 'BE',...)       | String         | -       |

    All props are transfered automatically to the generic child component. So for instance, passing props like \`placeholder\` or \`data-purpose-prop\` will be passed along. Another use case is to pass \`type="number"\` and all the necessary HTML attributes as props as well, such as \`max\`, \`min\`, \`step\`, etc.
    `)

    doc-markdown(source=`
    ### Events
  | Event name | Description                   | Parameters             | Usage      |
  |------------|-------------------------------|:----------------------:|------------|
  | input      | Triggered when input entered. | Event target value     | \`@input\` |
  | blur       | Triggered on blur from input. | -                      | \`@blur\`  |
  | focus      | Triggered focusing on input. | -                      | \`@focus\` |
    `)
</template>

<script>
export default {
  data () {
    return {
      value: null,
      displayError: false,
    };
  },
  computed: {
    error () { return this.displayError && this.value?.toLowerCase() !== 'brussels'; },
    errorMessage () { return this.value ? 'Wrong answer !' : 'Type something'; },
  },
};
</script>
